const origin='https://staff.invalid';
const keys=new Set(['q','role','developmentId','partyType','relationship','offset','building']);
/** Preserve only the local directory filters; never accept an embedded redirect or another record. */
export function contactListReturn(value:unknown):string|undefined{
 if(typeof value!=='string'||!value.startsWith('/contacts')||value.includes('\\')||/[\u0000-\u001f\u007f]/.test(value))return undefined;
 const url=new URL(value,origin),present=[...url.searchParams.keys()];
 if(url.origin!==origin||url.pathname!=='/contacts'||url.hash||present.some(key=>!keys.has(key))||new Set(present).size!==present.length)return undefined;
 return url.pathname+url.search;
}
